const MAX_SELECTED = 12;

/** Parse genes from URL. Empty / missing → no selection (never invent defaults). */
export function parseGenesParam(value: string | null, max = MAX_SELECTED): string[] {
  if (!value) return [];
  return value
    .split(',')
    .map(s => s.trim())
    .filter(Boolean)
    .slice(0, max);
}
